import {MoonIcon, SunIcon} from '../../../partials/icons';
import {pickTheme} from '../../../../../helpers/auth-helper';
import {blurAfterPointer} from '../../../../../helpers/focus';
import {otherTheme} from '../../../../../helpers/theme';
import {useShortcuts} from '../../../../../hooks/use-shortcuts';
import {useTheme} from '../../../../../hooks/use-theme';
import {useTranslation} from '../../../../../hooks/use-translation';

/**
 * Switches between the light and the dark theme (F8), for the logged in user on this terminal. It shows, and is named
 * after, the theme it switches to: a moon in the light theme.
 */
export const TopNavTheme = (): React.JSX.Element => {
    const t = useTranslation();
    const next = otherTheme(useTheme());
    const label = t('dark' === next ? 'topNav.darkTheme' : 'topNav.lightTheme');

    useShortcuts({F8: () => pickTheme(next)});

    return (
        <button
            type="button"
            className="button button-small"
            aria-label={label}
            title={label}
            onClick={event => {
                blurAfterPointer(event);
                pickTheme(next);
            }}
        >
            {'dark' === next ? <MoonIcon /> : <SunIcon />}
            <kbd>F8</kbd>
        </button>
    );
};
